// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"f7325a17","453":"ce912ecc"}[chunkId] + ".chunk.js";
};